export default "__VITE_ASSET__76ec6288__"